import React, { Component } from "react";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import TabDataUnitFJB from "./tabDataUnitFJB/tabDataUnitFJB";
import TabDataPersonalFJB from "./tabDataPersonalFJB/tabDataPersonalFJB";
import TabAnalisaFJB from "./tabAnalisaFJB/tabAnalisaFJB";
import TabDataTransaksiFJB from "./tabDataTransaksiFJB/tabDataTransaksiFJB";
import TabDataTambahanFJB from "./tabDataTambahanFJB/tabDataTambahanFJB";
import TabDataKeteranganFJB from "./tabDataKeteranganFJB/tabDataKeteranganFJB";

class FakturJualBengkelDetailContent extends Component {
  render() {
    return (
      <React.Fragment>
        <Tabs onSelect={tabIndex => this.props.onSetState({ activeTab: tabIndex })}>
          <TabList>
            <Tab id="button_navigate_data_unit">Data Unit</Tab>
            <Tab id="button_navigate_data_pemilik">Data Pemilik</Tab>
            <Tab id="button_navigate_data_pembawa">Data Pembawa</Tab>
            <Tab id="button_navigate_data_analisa">Analisa</Tab>
            <Tab id="button_navigate_data_transaksi">Data Transaksi</Tab>
            <Tab id="button_navigate_data_tambahan">Data Tambahan</Tab>
            <Tab id="button_navigate_data_keterangan">Keterangan</Tab>
          </TabList>
          <TabPanel>
            <TabDataUnitFJB {...this.props} />
          </TabPanel>
          <TabPanel>
            <TabDataPersonalFJB {...this.props} subtab="dataPemilik" />
          </TabPanel>
          <TabPanel>
            <TabDataPersonalFJB {...this.props} subtab="dataPembawa" />
          </TabPanel>
          <TabPanel>
            <TabAnalisaFJB {...this.props} />
          </TabPanel>
          <TabPanel>
            <TabDataTransaksiFJB {...this.props} />
          </TabPanel>
          <TabPanel>
            <TabDataTambahanFJB {...this.props} />
          </TabPanel>
          <TabPanel>
            <TabDataKeteranganFJB {...this.props} />
          </TabPanel>
        </Tabs>
      </React.Fragment>
    );
  }
}

export default FakturJualBengkelDetailContent;
